module.exports = __webpack_public_path__ + "static/media/facebook.821ab470.svg";